import { Pipe, PipeTransform } from "@angular/core";



@Pipe({ standalone: true, name: "pictureGenerator" })
export class PictureGeneratingPipeline implements PipeTransform {

    /**
     * 
     * @param user: UserData
     * @param size: string: (small - medium - original) `default: medium`
     * @returns url: User image url
     */
    transform(user: any, size= 'medium'): string {

        let urlavatar = 'https://d3puay5pkxu9s4.cloudfront.net/Users/';
        let picture = "";
        
        size = size == 'original' ? '' : size+'_';

        if (user.image?.includes('facebook') || user.image?.includes('google')) {
            picture = user.image;
        } else {
            picture = user.image == '' || !user.image ? urlavatar + (user.role == 'propietario' ? `${size}professor/imagen.jpg` : `default/${size}imagen.jpg`) : urlavatar + user.id + `/${size}` + user.image;
        }

        return picture;
    }
}